const Forgotpassword = () => {
    return (
        <>
            <div className="container">
                <div className="col-md-12">
                <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
                    <div className="card  shadow-sm" style={{ width: "100%", maxWidth: "400px" }}>
                            <div className="card-header">
                                <div className="card-title">Forgot Password</div>
                            </div>
                            <div className="card-body">
                                <form>
                                    <label className="form-label">Email / Username</label>
                                    <input
                                        type="email"
                                        placeholder="Enter Email or Username"
                                        className="form-control"
                                    />
                                    <p className="mt-3 text-danger"></p>
                                    <div className="text-end">
                                        <button className="btn btn-black mt-3 w-100">
                                            Generate OTP
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Forgotpassword;
